<section class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">
        <fa-icon [icon]="faUsers" />
        Finance Detail
      </h1>
      <app-navpath class="hidden md:block" />
    </div>
    <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <!-- Add -->
      <button *ngIf="mode === 'Add'" class="shorter-btn misc-btn" (click)="onSave()">
        <fa-icon [icon]="faPlus" class="mr-1" />Add
      </button>
  
      <!-- Edit -->
      <button *ngIf="mode === 'Edit'" class="shorter-btn misc-btn" (click)="onSave()">
        <fa-icon [icon]="faPencil" class="mr-1" />Update
      </button>
  
      <!-- Cancel -->
      <button class="shorter-btn clear-btn" (click)="onCancel()">
        <fa-icon [icon]="faBan" class="mr-1" />Cancel
      </button>
    </div>
    <div class="content-container">
      <app-data-form [dataFields]="formFields" dataName="formFields"></app-data-form>
    </div>
  </section>
  
